exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".resort-overview {\n  margin: 0.5em auto; }\n  .resort-overview__inner {\n    max-width: 1240px;\n    margin: 0 auto;\n    font-size: 0.9em;\n    text-align: center;\n    line-height: 2; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/resort-detail/resort-overview.component.scss
// module id = ../../../../../src/app/resort-detail/resort-overview.component.scss
// module chunks = main